import { CATEGORIES } from "../data/office";

export default function Marquee() {
  const items = CATEGORIES.map((c) => c.label);
  const row = [...items, ...items];

  return (
    <div
      data-testid="marquee-band"
      aria-label="Áreas de atuação do escritório"
      className="relative overflow-hidden border-y border-gold-500/20 bg-navy-950 py-5"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center">
            {row.map((label, i) => (
              <span
                key={`${copy}-${i}-${label}`}
                className="font-display flex items-center gap-8 whitespace-nowrap px-8 text-xl italic text-cream/70 sm:text-2xl"
              >
                {label}
                <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold-500" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
